import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import "./App.css";

import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingContact from "./components/FloatingContact";

import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Industries from "./pages/Industries";
import Products from "./pages/Products";
import Contact from "./pages/Contact";

import { Toaster } from "./components/ui/toaster";

function ScrollHandler() {
  const { pathname, hash, search } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash, search]);

  return null;
}

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white text-[#0a1929]">
      <Header />

      <main className="flex-1">
        {children}
      </main>

      <Footer />

      <FloatingContact />

      <Toaster />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollHandler />

      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/about" element={<About />} />

          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<Services />} />

          <Route path="/products" element={<Products />} />

          <Route path="/industries" element={<Industries />} />

          <Route path="/contact" element={<Contact />} />

          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;